import React, { Component } from 'react';
import {Route} from 'react-router-dom'

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import TopBar from './TopBar';
import Routes from './routes';

class App extends Component {
  render() {
    return (
      <MuiThemeProvider>
        <div>
          <TopBar/>
          <Route path="/" component={Routes} />
        </div>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js